import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { PostbackParameters } from './PostbackParameters.js';
import { actions } from './PostbackParameters.actions';
import {
    getHeaderNames,
    getData
} from './PostbackParameters.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    data: getData
});

const PostbackParametersComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.postbackParameters.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getPostbackParameters: actions.getPostbackParameters
        };
    }
)(PostbackParameters);

export default PostbackParametersComponent;
